import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  alerts: Array<object> = [];

  constructor() {
  }

  getAlerts() {
    return this.alerts;
  }

  addAlert(alert) {
    this.alerts.push(alert);
    setTimeout(() => {
      this.removeAlert(this.alerts.length - 1);
    }, 4000);
  }

  removeAlert(position, forceRemove = false) {
    console.log('alerts');
    console.log(this.alerts);
    if ((this.alerts.length > 0 && !this.alerts[position]['dontClose']) || forceRemove) {
      this.alerts.splice(position, 1);
    }
  }

}